<template>
  <div id="Bookdrop">
    <SidebarAdmin
      :setpacking="s"
      :orders="jobs"
      :setmyjob="myjobs"
      :setready="ready"
    />
    <div class="space"></div>
    <p class="packing">  </p>
    <div class="container">
      <div class="card-columns">
        <div v-for="(item, index) of packing" :key="index">
          <div class="card card-order-list card-margin border-light shadow">
            <div class="card-body">
              <h5 class="card-title">ออร์เดอร์ที่ {{ item.order_code }}</h5>

              <div class="card-content-more" v-if="!orderMore[item.order_id]">
                <p
                  class="btn-floating btn-large waves-effect waves-light pink tooltipped"
                  data-position="bottom"
                  data-delay="50"
                  data-tooltip="Add to favorites"
                  v-if="!orderMore[item.order_id]"
                  @click="orderShowMore(item.order_id)"
                >
                  <i class="fas fa-chevron-circle-down fa-lg"></i>
                  <!-- <i class="fas fa-ellipsis-h"></i> -->
                </p>
              </div>
              <div class="card-content-more" v-if="orderMore[item.order_id]">
                <p
                  class="btn-floating btn-large waves-effect waves-light pink tooltipped"
                  data-position="bottom"
                  data-delay="50"
                  data-tooltip="Add to favorites"
                  v-if="orderMore[item.order_id]"
                  @click="orderShowLess(item.order_id)"
                >
                  <i class="fas fa-chevron-circle-up fa-lg"></i>
                  <!-- <i class="fas fa-ellipsis-v"></i> -->
                </p>
              </div>
              <div v-if="orderMore[item.order_id]">
                <div
                  class="card-text"
                  v-for="(prod, j) of item.order_detail"
                  :key="j"
                >
                  <div class="card card-order-list_ border-light shadow">
                    <h6
                      class="card-title"
                      v-if="!readMore[prod.order_detail_id]"
                    >
                      <!-- https://www.myprincipallifestyle.com/assets/img/loading.gif -->
                      <!-- https://www.superiorlawncareusa.com/wp-content/uploads/2020/05/loading-gif-png-5.gif -->
                      <img
                        src="https://www.myprincipallifestyle.com/assets/img/loading.gif"
                        alt=""
                        style="width: 20px; height: auto"
                        v-if="prod.trans_status === 0"
                      />
                      <!-- <i class="fas fa-spinner fa-sm" style="color:blue" v-if="prod.trans_status === 0"></i> -->
                      <i
                        class="fas fa-check-circle fa-green fa-sm"
                        v-if="prod.trans_status === 1"
                      ></i>
                      <i
                        class="far fa-times-circle fa-sm"
                        style="color: red"
                        v-if="prod.trans_status === 2"
                      ></i>

                      {{ prod.book_title.slice(0, 49) }}
                      <a
                        v-if="
                          !readMore[prod.order_detail_id] &&
                            prod.book_title.length > 49
                        "
                        @click="showMore(prod.order_detail_id)"
                        >[...]</a
                      >
                    </h6>

                    <h6
                      class="card-title"
                      v-if="readMore[prod.order_detail_id]"
                    >
                      <img
                        src="https://www.myprincipallifestyle.com/assets/img/loading.gif"
                        alt=""
                        style="width: 20px; height: auto"
                        v-if="prod.trans_status === 0"
                      />
                      <!-- <i class="fas fa-spinner" style="color:blue" v-if="prod.trans_status === 0"></i> -->
                      <i
                        class="fas fa-check-circle fa-green fa-sm"
                        v-if="prod.trans_status === 1"
                      ></i>
                      <i
                        class="far fa-times-circle fa-sm"
                        style="color: red"
                        v-if="prod.trans_status === 2"
                      ></i>
                      {{ prod.book_title }}
                      <a
                        v-if="readMore[prod.order_detail_id]"
                        @click="showLess(prod.order_detail_id)"
                        >[ย่อ]</a
                      >
                    </h6>
                  </div>
                </div>
              </div>
              <!-- <div class="content-status">
                <button
                  class="btn btn-primary btn-status-info"
                  @click="setstatus(item)"
                >
                  To ready
                </button>
              </div> -->
              <p class="card-text">
                <small class="text-muted">
                  <i class="fas fa-calendar-alt"></i>วันรับ :
                  {{ item.mustbeget_date | moment }}
                  <!-- {{moment(item.mustbeget_date).fromNow()}} -->
                  <i v-if="item.order_status === 1">
                    <img
                      src="../../assets/icons/alram.gif"
                      alt=""
                      style="width: 23px; height: auto"
                    />
                    รีบดำเนินการ
                  </i>

                  <i v-if="item.order_status === 2">
                    <img
                      src="https://www.superiorlawncareusa.com/wp-content/uploads/2020/05/loading-gif-png-5.gif"
                      alt=""
                      style="width: 15px; height: auto"
                    />
                    กำลังดำเนินการ
                  </i>
                </small>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SidebarAdmin from "../layouts/sidbar-admin.vue";
import axios from "axios";
import moment from "moment";
export default {
  components: { SidebarAdmin },
  name: "Bookdrop",
  data() {
    return {
      token: "dQpojB8WkH7HAZdh223jaqFSB1x5RYoKBjU0BAaVZt8DTVaxO5Sx5DlsErA2Zsu",
      packing: [],
      readMore: {},
      show: false,
      orderMore: {},
      status: "",
      jobs: [],
      myjobs: [],
      ready: [],
      isLoading: false,
      code: "",
    };
  },
  mounted() {
    if(localStorage.getItem("auth") !=null){
      let c = JSON.parse(localStorage.getItem("auth"));
    this.code = c.std_code;
    }
    this.getpacking();
  },
  filters: {
    moment: function(date) {
      moment.locale("th");
      return moment(date)
        .add(543, "year")
        .format("LLLL");
    },
  },
  methods: {
    moment: function() {
      return moment();
    },
    setstatus(item) {
      let IP = localStorage.getItem("IP");
      let datapacking = {
        token: this.token,
        staff_code: this.code,
        order_code: item.order_code,
        order_status: item.order_status,
        public_ip: IP,
      };
      const headers = {
        "content-type": "application/json",
      };
      axios
        .post(
          "https://smartlibrary.ubru.ac.th/api/booking/set_order_status",
          datapacking,
          {
            headers,
          }
        )
        .then((res) => {
          if (item.order_code === res.data.Orders[0].order_code) {
            if (res.data.Orders[0].order_status === 4) {
              this.packing.splice(this.packing.indexOf(item), 1);
              this.s = this.packing.length;
              this.ready = res.data.dasboard[0].ready;
              this.jobs = res.data.dasboard[0].neworders;
              this.myjobs = res.data.dasboard[0].myjob;
            }
          }
        });
    },
    getpacking() {
      let datapacking = {
        token: this.token,
        staff_code: this.code,
      };
      const headers = {
        "content-type": "application/json",

      };
      this.$isLoading(true);
      axios
        .post(
          "https://smartlibrary.ubru.ac.th/api/booking/get_packing",
          datapacking,
          {
            headers,
          }
        )
        .then((res) => {
          this.packing = res.data.Orders;
          this.s = this.packing.length;
          this.ready = res.data.dasboard[0].ready;
          this.jobs = res.data.dasboard[0].neworders;
          this.myjobs = res.data.dasboard[0].myjob;
          //  setTimeout(this.getpacking(), 4000);
          this.$isLoading(false);
        });
    },

    showMore(id) {
      this.$set(this.readMore, id, true);
    },
    showLess(id) {
      this.$set(this.readMore, id, false);
    },
    orderShowMore(id) {
      this.$set(this.orderMore, id, true);
    },
    orderShowLess(id) {
      this.$set(this.orderMore, id, false);
    },
  },
};
</script>

<style scoped>
@media  screen and (max-width: 1024px) {
 .packing:before{
      content: "packing";
      background-color: rgb(90, 59, 2);
      width: 100px;
    height: 40px;
    z-index: 1030;
    font-size: 20px;
    /* border-radius: 60%; */
    color: white;
    padding: 5px;
    
  position: fixed;
  /* top: 360px; */
  right: 0px;
  }
}
.card-order-list_ {
  padding: 25px;
}
.btn-floating {
  position: absolute;
  /* width: 46px;
  height: 40px;
  background: rgb(120, 90, 227);
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  font-size: 12px; */
  top: -54px;
  right: -20px;
  /* top: -100px; */
  font-size: 14px;
  color: rgb(79, 159, 0);
}
.fa-green {
  color: rgb(79, 159, 0);
}
.space {
  height: 70px;
}
.two {
  height: 1000px;
}
.text-muted i {
  margin: 0 5px;
}

a {
  color: rgba(70, 5, 97, 0.961);
}
a:hover {
  text-decoration: initial;
  color: rgb(90, 5, 187);
}

.card-margin {
  margin-bottom: 1.875rem;
}
.card-order-list {
  padding: 5px;
}
.card-margin-orderlist {
  margin-bottom: 1rem;
}
@media (max-width: 1199px) {
  .btn-floating {
    position: absolute;
    top: -54px;
    right: -20px;
    /* top: -100px; */
    font-size: 14px;
    color: rgb(79, 159, 0);
  }
}
@media (min-width: 768px) {
  .card-columns {
    column-count: 3;
  }
}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) {
  .card-columns {
    column-count: 3;
  }
}

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {
  .card-columns {
    column-count: 3;
  }
}
.card-content-more {
  position: relative;
}

.fa-purple {
  color: rgb(109, 7, 172);
}
.card-title {
  text-align: left;
  /* text-align: justify; */
  bottom: 10px;
}
.card-text {
  text-align: left;
  line-height: 23px;
  /* bottom: 5px; */
}
</style>
